import { cloudinaryImageUrl, IMAGE_WIDTH } from "../../../utils/cloudinaryDelivery";

// The gallery section of the booking page: the pro's portfolio tiles.

export const normalizeGalleryItems = (value) =>
  (Array.isArray(value) ? value : [])
    .map((item, index) => {
      const url = typeof item?.url === "string" ? item.url.trim() : "";
      if (!url) return null;

      const alt =
        typeof item?.alt === "string" && item.alt.trim()
          ? item.alt.trim()
          : typeof item?.caption === "string" && item.caption.trim()
            ? item.caption.trim()
            : `Portfolio image ${index + 1}`;

      return {
        id:
          (typeof item?.id === "string" && item.id.trim()) ||
          (typeof item?._id === "string" && item._id.trim()) ||
          `gallery-${index}`,
        url,
        alt,
        caption:
          typeof item?.caption === "string" ? item.caption.trim() : "",
      };
    })
    .filter(Boolean);

// A page without pictures has no gallery at all. The editor keeps an empty
// state so the owner can see where the pictures will go.
const ProfileGallerySection = ({ items = [], editorMode = false }) => {
  if (items.length === 0 && !editorMode) return null;

  // No heading in the design — the tiles speak for themselves — so the
  // section carries its name for assistive tech instead.
  return (
    <section className="profile-gallery" aria-label="Portfolio">
      {items.length === 0 ? (
        <div className="profile-gallery__empty">
          <p>Add gallery images in your profile settings to showcase your work.</p>
        </div>
      ) : (
        <div className="profile-gallery__grid">
          {items.map((item) => (
            <figure key={item.id} className="profile-gallery__item">
              <img src={cloudinaryImageUrl(item.url, { width: IMAGE_WIDTH.gallery })} alt={item.alt} loading="lazy" />
              {item.caption && (
                <figcaption>{item.caption}</figcaption>
              )}
            </figure>
          ))}
        </div>
      )}
    </section>
  );
};

export default ProfileGallerySection;
